import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { getBlog } from "./blogApi";

const initialState = {
    blog: {},
    isLoading: false,
    isError: false,
    error: "",
};

// async thunk
export const fetchSingleBlog = createAsyncThunk(
    "blog/fetchSingleBlog",
    async (blogId) => {
        const blog = await getBlog(blogId);
        return blog;
    }
);

const blogSlice = createSlice({
    name: "blog",
    initialState,
    extraReducers: (builder) => {
        builder
            .addCase(fetchSingleBlog.pending, (state) => {
                state.isError = false;
                state.isLoading = true;
            })
            .addCase(fetchSingleBlog.fulfilled, (state, action) => {
                state.isLoading = false;
                state.blog = action.payload;
            })
            .addCase(fetchSingleBlog.rejected, (state, action) => {
                state.isLoading = false;
                state.blog = {};
                state.isError = true;
                state.error = action.error?.message;
            });
    },
});

export default blogSlice.reducer;
